import * as React from 'react'
import { Date } from '../Fields/Date'
import { MultipleCheckbox } from '../Fields/MultipleCheckbox'
import { OutlinedInput } from '../Fields/OutlinedInput'
import { ToggleButton } from '../Fields/ToggleButton'
import { LegalTerm } from '../Fields/LegalTerm'
import { LegalStatement } from '../Fields/LegalStatement'

export const FieldPicker = ({
  type,
  recaptchaRef,
  setFieldValue,
  ...props
}) => {
  switch (type) {
    case 'date':
      return <Date {...props} />
    case 'multipleCheckbox':
      return <MultipleCheckbox setFieldValue={setFieldValue} {...props} />
    case 'toggleButton':
      return <ToggleButton setFieldValue={setFieldValue} {...props} />
    case 'legalTerm':
      return <LegalTerm {...props} />
    case 'legalStatement':
      return <LegalStatement {...props} />
    case 'captchaVerification':
      return
    default:
      return <OutlinedInput {...props} />
  }
}
